/**
 * File: aria-social-links.js
 *
 * Import and initialize functions for social icons
 */

export default {
	init() {
		this.render();
	},
	render() {
		//Social links
		const socialGroups = document.querySelectorAll('.socials_mobile, .wwav-social');

		socialGroups?.forEach(group => {
			const links = group.querySelectorAll('a');

			links?.forEach(link => {
				const textSource = link.querySelector('*[class^="icon-"]')?.className || link.querySelector('i')?.className;

				if (textSource?.includes('fa-')) {
					const trimmedText = textSource.replace('fa-', 'icon ').replace('-play', '');

					link.setAttribute('aria-label', trimmedText);
					return;
				}

				const trimmedText = textSource?.replace('-', ' ');

				link.setAttribute('aria-label', trimmedText);
			});
		});

		//Search button
		const searchLink = document.querySelector('.menu_mobile_inner .search_submit');

		searchLink.setAttribute('aria-label', 'search button');

		//Close button
		const closeButton = document.querySelector('.menu_mobile_inner .menu_mobile_close');

		closeButton.setAttribute('aria-label', 'close button');
	},
};
